import React from "react";
import { Heading } from "@telia/teddy";

const SalesReportsHome: React.FC = () => (
    <div className="retailer-dashboard-wrapper">
        <Heading mb="100" as="h1" variant="title-300">
            Salgsrapporter
        </Heading>
    </div>
);

export default SalesReportsHome;
